<template>
  <section>
    <h1 class="text-lg font-semibold">{{ $t('windows.documents.legal.title') }}</h1>
    <hr class="mt-2 mb-2 border-t-1 border-black" />
    <p class="text-sm mb-3">{{ $t('windows.documents.legal.firstParagraph') }}</p>

    <h2 class="text-base font-semibold">{{ $t('windows.documents.legal.edit') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="text-sm">{{ $t('windows.documents.legal.secondParagraph') }}</p>
    <p class="text-sm mb-3">{{ $t('windows.documents.legal.thirdParagraph') }}</p>

    <h2 class="text-base font-semibold">{{ $t('windows.documents.legal.hosting') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="text-sm mb-3">{{ $t('windows.documents.legal.fourthParagraph') }}</p>

    <h2 class="text-base font-semibold">{{ $t('windows.documents.legal.dirPublication') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="text-sm mb-3">{{ $t('windows.documents.legal.fifthParagraph') }}</p>

    <h2 class="text-base font-semibold">{{ $t('windows.documents.legal.contact') }}</h2>
    <hr class="mt-1 mb-2 border-t-1 border-gray-400" />
    <p class="text-sm">{{ $t('windows.documents.legal.sixthParagraph') }}</p>
    <p class="text-sm mb-3">haris.naveed174@gmail.com</p>
  </section>
</template>
